var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7003 32.1181C37.8939 31.616 38 31.0704 38 30.5C38 28.1564 36.2085 26.2313 33.9203 26.0194C33.4522 23.1721 30.9798 21 28 21C27.5534 21 27.1183 21.0488 26.6995 21.1413M23.2875 23.2859C22.6732 24.0642 22.2476 24.9984 22.0797 26.0194C19.7915 26.2313 18 28.1564 18 30.5C18 32.9853 20.0147 35 22.5 35H33.5C33.9561 35 34.3963 34.9322 34.8112 34.806M19 19L37 37",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOffIcon);
export default __webpack_public_path__ + "static/media/cloud-off-icon.82f73f9cf31441977e5f5e213440c2fd.svg";
export { ForwardRef as ReactComponent };